import React from 'react';

import { StyledSnackbar } from './styles';

export interface SnackbarProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
}

const Snackbar: React.FC<SnackbarProps> = ({ message, ...props }) => {
  return (
    <StyledSnackbar role="alert" id="snackbar" {...props}>
      {message}
    </StyledSnackbar>
  );
};

export default Snackbar;
